<template>
  <dialog-email
    ref="dialog-email"
    :contentKey="contentKey"
    :contentMap="contentMap"
    :data="data"
    :isLoading="isLoading"
    @on-submit-email="handlerSubmit"
  ></dialog-email>
</template>

<script>
import { createParams } from '@/utils/dynamic'
import { ServiceEmailMessages } from '@/services/email-messages'
import { ServiceCustomerPOFollowUp } from '@/services/CustomerPOFollowUp'

export default {
  name: 'DialogStatusRequestEmailCustomer',
  components: {
    'dialog-email': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogEmail/index')
  },
  data () {
    return {
      isLoading: false,
      id: null,
      subject: null,
      requestData: null,
      data: {},
      contentMap: {},
      cb: () => {}
    }
  },
  created () {
    this.$bus.$on('on-status-email-request-customer', this.show)
  },
  beforeDestroy () {
    this.$bus.$off('on-status-email-request-customer', this.show)
  },
  computed: {
    contentKey () {
      return 'status-request-email-customer-followup'
    }
  },
  methods: {
    loadData () {
      this.isLoading = true
      const params = createParams({
        select: [
          'id', 'po', 'part.partNumber as partNumber', 'partSN', 'lastInfo',
          'rfq3.rfq.baxEmployee.contact.email as baxEmployeeEmail',
          'rfq3.rfq.customerContact.name as customerContactName', 'rfq3.rfq.customerContact.email as customerContactEmail'
        ].join(','),
        filter: `id == ${this.id}`
      })
      return ServiceCustomerPOFollowUp.getAllDynamic(params)
        .then(({ data }) => {
          if (data.value[0]) {
            this.requestData = data.value[0]
          } else {
            throw Error()
          }
        })
        .then(() => {
          this.createMapData()
          this.createEmailData()
        })
        .catch(err => {
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    createMapData () {
      this.contentMap = {
        ...this.requestData,
        subject: this.subject
      }
    },
    createEmailData () {
      const { po, customerContactEmail, baxEmployeeEmail } = this.requestData
      const subject = `${this.L10n('order-followup-email-subject')}: ${po}`

      const emailToList = Array.from(new Set([customerContactEmail, baxEmployeeEmail].filter(Boolean)).values())

      this.data = {
        subject,
        emailToList
      }
    },
    show ({ subject, id }, cb) {
      this.cb = cb
      this.id = id
      this.subject = subject

      this.$refs['dialog-email'].show()
      this.loadData()
    },
    hide () {
      this.$refs['dialog-email'].hide()
      this.isLoading = false
    },
    handlerSubmit (data) {
      this.isLoading = true
      return ServiceEmailMessages.send(data)
        .then(() => {
          if (typeof this.cb === 'function') {
            this.cb({
              ...data,
              customerContactName: this.requestData.customerContactName,
              customerContactEmail: this.requestData.customerContactEmail
            })
          }
          this.hide()
        })
        .catch((err) => {
          this.isLoading = false
          this.requestErrorHandler(err)
        })
    }
  }
}
</script>
